/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowsDownUp: {
  name: 'arrows_down_up';
  data: string;
} = {
  name: 'arrows_down_up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M11.03 15.97a.75.75 0 0 1 0 1.06l-3 3a.748.748 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V4.5a.75.75 0 0 1 1.5 0v13.19l1.72-1.72a.75.75 0 0 1 1.06 0Zm9-9-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 1.06 1.06l1.72-1.72V19.5a.75.75 0 1 0 1.5 0V6.31l1.72 1.72a.75.75 0 1 0 1.06-1.06Z" fill="currentColor"/></svg>`
};
